import { render, staticRenderFns } from "./GdprExport.vue?vue&type=template&id=e4c24bdc&lang=pug&"
import script from "./GdprExport.vue?vue&type=script&lang=ts&"
export * from "./GdprExport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\as3-portals\\AS3.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4c24bdc')) {
      api.createRecord('e4c24bdc', component.options)
    } else {
      api.reload('e4c24bdc', component.options)
    }
    module.hot.accept("./GdprExport.vue?vue&type=template&id=e4c24bdc&lang=pug&", function () {
      api.rerender('e4c24bdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "shared-components/GdprExport.vue"
export default component.exports